import commonMixin from '../../mixins/_common';
import flashMessageMixin from '../../mixins/_flash_messages';

/**
 * タイトル編集のコンポーネント
 */
export default {
    name: 'titleEdit',
    template: '#title_edit_template',
    data() {
        return {
            // 編集中フラグ
            editing: false,
            // 編集中のタイトル
            edit_value: null,
        };
    },
    props: {
        // v-modelの値(タイトル)
        modelValue: {
            type: String,
            default: '',
        },
        // ページキー
        page_key: {
            type: String,
            default: '',
        }
    },
    mixins: [
        commonMixin,
        flashMessageMixin,
    ],
    emits: [
        'update:modelValue',
        'update_edited',
    ],
    methods: {
        // 編集開始
        editStart: function () {
            this.edit_value = this.modelValue;
            this.editing = true;
            this.focus(true);
        },
        // 保存する
        save: async function () {
            await this.focus(false);
            const $form = this.$refs.form;
            // 通常のHTML5バリデーションエラー
            if (!$form.checkValidity()) {
                $form.reportValidity();
                return;
            }

            let html5ValidMessage = '';
            let message = this.exception_error_message;
            try {
                this.$_loading();
                const response = await yahooAxios.get('/custom_page/is_unique_name', {
                    params: {
                        name: this.edit_value,
                        key: this.page_key
                    }
                });
                if (response.data.status === 'OK') {
                    // エラーメッセージを空にする
                    message = '';
                    // 閉じて更新
                    this.editing = false;
                    this.emitUpdateValue();
                } else {
                    // NGのレスポンスでも正常な返答
                    message = '';
                    html5ValidMessage = 'このタイトルはすでに使われています。';
                }
            } catch (e) {
                await this.$root.$refs.yahooAuth.error(e);
                message = '';
            }
            this.$_unloading();

            // HTML5バリデーション表示
            this.$refs.titleEditInput.setCustomValidity(html5ValidMessage);
            if (!$form.checkValidity()) {
                $form.reportValidity();
            }
            // フラッシュメッセージ表示
            if (message) {
                this.appendFlashMessage({
                    level: 'alert-danger',
                    message: message,
                }, this.$root);
            }
        },
        // フォーカスの切り替え
        focus: async function (bool) {
            await this.$nextTick();
            this.$refs.titleEditInput.setFocus(bool);
        },
        // 保存しないで編集エリアを閉じる
        cancel: function() {
            this.editing = false;
        },
        // -------------------------
        // emit
        // -------------------------

        // 親へ通知
        emitUpdateValue: function () {
            this.$emit('update:modelValue', this.edit_value);
            this.$emit('update_edited', true);
        }
    }
};

